import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "../lib/supabase";



type AdminRouteProps = {
  children: React.ReactNode;
};

const ADMIN_EMAIL = "rathorprince938@gmail.com";

const AdminRoute = ({ children }: AdminRouteProps) => {
  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      const { data, error } = await supabase.auth.getUser();

      if (error) {
        console.error("Error checking auth:", error);
        setAllowed(false);
        setLoading(false);
        return;
      }

      const user = data?.user;

      if (user && user.email === ADMIN_EMAIL) {
        setAllowed(true);
      } else {
        setAllowed(false);
      }

      setLoading(false);
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <main className="min-h-screen flex items-center justify-center">
        <p>Checking admin access...</p>
      </main>
    );
  }

  if (!allowed) {
    return <Navigate to="/admin/login" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
